import { styled } from "@mui/material/styles";
import { ColorTextMedium, ColorGray300, SizeBorderWidthThin, ColorGray600, RadiusMd, SpaceSm, SpaceXs, FontSize300 } from "@nxt-costco-com/forge-design-tokens";
const buttonStyles = {
  alignItems: "center",
  display: "flex",
  fontSize: FontSize300,
  height: "100%",
  justifyContent: "center",
  lineHeight: "initial",
  minHeight: "40px",
  padding: `${SpaceSm} ${SpaceXs}`,
  position: "relative",
  width: "100%",
  zIndex: 2
};
const StyledOutOfStockIndicator = styled("div")({
  ...buttonStyles,
  borderRadius: RadiusMd,
  border: `${SizeBorderWidthThin} solid ${ColorGray600}`,
  background: ColorGray300,
  color: ColorTextMedium
});
export {
  StyledOutOfStockIndicator,
  buttonStyles
};
